import { Button, Card, Form, Input, Typography, message,Checkbox  } from 'antd';

const { Text } = Typography;
function NewPassword() {
	return ( 
		<div className="Login-page">
	  <Card className="card-custom">
		<Typography.Title level={2} className="text-center text-gray-800 mb-6">
			Reset Password
		</Typography.Title>
		<Form
		  name="login_form"
		  layout="vertical"
		  initialValues={{ remember: true }}
		  size='large'
		>
		  <Form.Item
			name="password"
			rules={[{ required: true, message: 'New password is required!' }]}
		  >
			<Input.Password
			  // prefix={<UserOutlined className="text-gray-500" />}
			  placeholder="Enter new password"
			  className="rounded-lg"
			/>
		  </Form.Item>

		  <Form.Item
			name="cofirm_password"
			rules={[{ required: true, message: 'Confirm new password is required!' }]}
		  >
			<Input.Password
			  // prefix={<LockOutlined className="text-gray-500" />}
			  placeholder="Confirm new password"
			  className="rounded-lg"
			/>
		  </Form.Item>

		  <Form.Item>
			<Button type="primary" htmlType="submit" block className="h-10 rounded-lg bg-blue-600 hover:bg-blue-700">
			   Change Password
			</Button>
		  </Form.Item>

		<Text italic className="block text-center text-gray-800 mb-6 w-fit mx-auto">
			If you didn’t request a password change, please ignore this
		</Text>
		</Form>
	  </Card>
	</div>
	 );
}

export default NewPassword;